import React, { useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import signOutImg from '../../assets/svg/brand-logos/signout.svg';
import { resolveAvatarSrc } from 'utils/avatar';

// Minimal profile avatar shown in top-right as a circle. No Nav wrapper.
export const Signout = () => {
  // read auth slice; be tolerant of nesting differences
  const auth = useSelector(x => x.auth) || {};
  const authUserWrapper = auth.user || null; // could be { user: { ... } } or user object directly
  const profile = authUserWrapper ? (authUserWrapper.user || authUserWrapper) : null;

  const [avatar, setAvatar] = useState(signOutImg);

  useEffect(() => {
    const avatarSrc = resolveAvatarSrc(profile?.avatarUrl || profile?.avatar || '');
    if (avatarSrc) {
      setAvatar(avatarSrc);
    } else {
      setAvatar(signOutImg);
    }
  }, [profile]);

  const profileLink = profile && profile._id ? `/profile/${profile._id}` : '/profile';

  return (
    <div style={{ position: 'fixed', top: "0.5vh", right: "0.5vh" }}>
      <Link to={profileLink} title="Profile">
        <Image
          src={avatar}
          alt="Profile"
          roundedCircle
          style={{ width: 64, height: 64, objectFit: 'cover', border: '2px solid rgba(255,255,255,0.1)' }}
        />
      </Link>
    </div>
  );
};